"use strict";

exports.__esModule = true;
exports.DEFAULT_OPTIONS = void 0;
const DEFAULT_OPTIONS = {
  enableDownload: true,
  // whether to show the download button in the toolbar - boolean
  enablePageNav: true,
  // whether to show the page navigation in the toolbar - boolean
  enableZoom: true,
  // whether to show the zoom level in the toolbar - boolean
  enablePrint: true,
  // whether to show the print button in the toolbar - boolean
  enableFullscreen: true,
  // whether to show the fullscreen button in the toolbar - boolean
  showToolbar: true,
  // whether to show the toolbar - boolean
  toolbarPosition: 'bottom',
  // the toolbar position - string either 'top' or 'bottom'
  initialPage: 1,
  // the initial page to show when the document is previewed - integer
  maxNumberOfPages: 100,
  // the maximum number of pages a document can have to enable preview - integer
  minZoom: 25,
  // the minimum zoom percentage - integer
  maxZoom: 400,
  // the maximum zoom percentage - integer
  zoomIncrement: 25,
  // the zoom increment amount when clicking the toolbar buttons - integer
  mobileDocumentWidth: '90%',
  // initial document page width percentage on mobile breakpoints
  desktopDocumentWidth: '90%',
  // initial document page width percentage on desktop breakpoints
  maxDocumentWidth: '800px',
  // maximum document page width in pixels
  loadingLabel: 'Loading...',
  // the label to show when the document is loading - string
  renderingLabel: 'Rendering...',
  // the label to show when the document is rendering - string
  printingNotSupportedMessage: 'Printing is not supported in this browser. Please download the file to print this document.',
  httpHeaders: {},
  // http headers to send when fetching the pdf document
  backgroundColor: null,
  // the background colour of the PDF viewer
  toolbarBackgroundColor: null,
  // the toolbar background colour
  toolbarTextColor: null,
  // the toolbar text colour
  toolbarIconColor: null,
  // the toolbar icon colour
  toolbarSeparatorColor: null,
  // the toolbar separator colour
  toolbarButtons: [],
  previewUnavailableButtons: []
};
exports.DEFAULT_OPTIONS = DEFAULT_OPTIONS;